module.exports = __webpack_public_path__ + "static/media/whatsapp.47d6578f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/whatsapp.svg
// module id = 31
// module chunks = 0